import React from "react";
import { Form } from "antd";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import TickBox from "../../../core/ui/components/grid/TickBox";
import { IIndexType } from "../../model/IndexType";
import IndexTypeForm from "./IndexTypeForm";
import { IIndexTypeAttribute } from "../../model/IndexTypeAttribute";

interface IndexTypeGridProps {
  translate: any;
  referenceLoader?: boolean;
  indexTypes: IIndexType[];
  updateIndexType?: any;
  deleteIndexType?: any;
  onStartUpdateIndexType?: any;
  indexTypeAttributes?: IIndexTypeAttribute[];
  createIndexTypeAttribute?: any;
  deleteIndexTypeAttribute?: any;
}
const IndexTypeGrid: React.FC<IndexTypeGridProps> = ({
  translate,
  referenceLoader,
  indexTypes,
  updateIndexType,
  deleteIndexType,
  onStartUpdateIndexType,
  indexTypeAttributes,
  createIndexTypeAttribute,
  deleteIndexTypeAttribute
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.index_type_categories"
  });
  const columns = builder.buildColumns("code", "name", "description", {
    name: "valid",
    dataKey: "valid",
    sortable: false,
    align: "center",
    render: (record) => <TickBox value={record.valid} />
  });

  const [UpdateForm] = Form.useForm();

  return (
    <DataGrid
      title={translate("editors.index_types.title")}
      columns={columns}
      translate={translate}
      dataSource={indexTypes || []}
      allowCreate={false}
      allowUpdate={updateIndexType}
      allowDelete={deleteIndexType}
      loading={referenceLoader}
      booleanColumnKeys={["valid"]}
      createModalClass={"modal-width"}
      updateModalClass={"modal-width"}
      keyProperty={"id"}
      createActionPosition={"topRight"}
      onDelete={(e) => deleteIndexType(e)}
      onUpdate={(e) => updateIndexType(e)}
      onStartUpdate={(e) => onStartUpdateIndexType(e)}
      UpdateFormInstance={UpdateForm}
      updateForm={
        <IndexTypeForm
          form={UpdateForm}
          translate={translate}
          indexTypeAttributes={indexTypeAttributes}
          createIndexTypeAttribute={createIndexTypeAttribute}
          deleteIndexTypeAttribute={deleteIndexTypeAttribute}
        />
      }
      deleteModalTitle={translate("editors.index_types.delete_title")}
      deleteModalMessage={translate("editors.index_types.delete_modal")}
    />
  );
};
export default IndexTypeGrid;
